import { Stack } from "@mui/material";
import { SettingRow } from "@src/appV2/redesign/components/SettingRow";
import { useState } from "react";

import { Text } from "../../components/Text";
import { TextInput } from "../../components/TextInput";

interface SettingNumberInputProps {
  title: string;
  subtitle?: string;
  value: number;
  disabled?: boolean;
  min?: number;
  max?: number;
  unit?: string;
  onChange: (value: number) => void;
}

export function SettingNumberInput({
  title,
  subtitle,
  value,
  disabled = false,
  min,
  max,
  unit,
  onChange,
}: SettingNumberInputProps) {
  const [localValue, setLocalValue] = useState(String(value));

  return (
    <SettingRow
      title={title}
      subtitle={subtitle}
      disabled={disabled}
      action={
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <TextInput
            type="number"
            value={localValue}
            disabled={disabled}
            inputProps={{ min, max, "aria-label": title }}
            sx={{ width: 80 }}
            onBlur={() => {
              const parsed = Number(localValue);
              if (localValue !== "" && !Number.isNaN(parsed) && parsed !== value) {
                onChange(parsed);
              } else {
                setLocalValue(String(value));
              }
            }}
            onChange={(event) => {
              setLocalValue(event.target.value);
            }}
          />
          {unit && (
            <Text variant="body2" sx={(theme) => ({ color: theme.palette.text.secondary })}>
              {unit}
            </Text>
          )}
        </Stack>
      }
    />
  );
}
